import axios from 'axios';
import { refreshToken } from './AuthRoute';
import { Toast } from 'src/components/shared/NotificationToast';

let navigate; // Declare a variable to hold the navigate function

export const setNavigate = (navigateFunction) => {
  navigate = navigateFunction; // Assign the navigate function
};

let isRefreshing = false; // to avoid multiple token fetch situations
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error); // if failed, fails for all the attempts
    } else {
      promise.resolve(token); // if token generated, same is used for all attempts
    }
  });

  failedQueue = [];
};

axios.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // if token already exists then add that in the header
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use( // runs on every error 
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      !error.response ||
      originalRequest.url.includes('/auth/login') ||
      originalRequest.url.includes('/auth/register') ||
      originalRequest.url.includes('/auth/refresh-tokens')
    ) {
      return Promise.reject(error); // skips the refresh logic in login or refresh tokens
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject }); // creates a promise and adds on the queue
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newToken = await refreshToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
        processQueue(null, newToken);
        return axios(originalRequest); // uses the same token for all request
      } catch (err) {
        processQueue(err, null);
        localStorage.clear();
        Toast({ type: 'error', message: 'Session expired. Please log in again.' });
        if (navigate) navigate('/auth/login'); // if refresh fails
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);